import React, { useState } from 'react';
import {StatusIndicator} from "../StatusIndicator";
import {toggleStatus} from "../../hooks/useToggleSection";

const Speaker = ({speaker, showToggle}) => {
	const [isActive, setIsActive] = useState(false);
	const detailsOpenClass = isActive ? 'show' : 'hide';
	const speakerPhotoStyle = {
		backgroundImage: `url("${speaker.imageUrl}")`,
	}

	const MaybeShowFulltext = () => {
		if (isActive && showToggle) {
			return (
				<p className="full-bio" dangerouslySetInnerHTML={{__html: speaker.bio}}></p>
			)
		}

		return null;
	}

	return (
		<article className={`event-info-item speaker-details ${detailsOpenClass}`} key={speaker.ID} onClick={() => toggleStatus(setIsActive, isActive)}>

			<figure className={'speaker-photo'} style={speakerPhotoStyle}></figure>

			<div className="copy">
				<div className="vert">
					<h2>{speaker.name}</h2>

					<StatusIndicator isActive={isActive} show={showToggle}/>

					<div className="job-information">
						<p>{speaker.title}</p>
					</div>
				</div>
			</div>

			<MaybeShowFulltext />
		</article>
	)
}

export default Speaker;
